/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { CLONE_LIST } from 'constants/types/audienceTypesNew';
import { AUDIENCE_LISTS, AUDIENCE_LISTS_SEARCH, AUDIENCE_LISTS_DELETE, AUDIENCE_LISTS_ADD, AUDIENCE_LISTS_SELECTION } from 'constants/types';
import { IAudienceListState, IListItem, IAudienceListAction, IListItemNames } from '../interface';
import { ActionTypes } from '../constants';

const audienceListsInitialState: IAudienceListState = {
  lists: Array<IListItem>(),
  totalLists: 0,
  totalSearchedLists: 0,
  loading: false,
  listAlreadyExists: false,
  page: 0,
  message: '',
  success: false,
  searchTerm: '',
  searchedLists: Array<IListItem>(),
  searchedLoading: false,
  searchedPage: 0,
  listsDataNamesLoading: false,
  listsDataNames: Array<IListItemNames>(),
  addNewList: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  editList: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  deleteList: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  cloneList: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  exportPopup: {
    loading: false,
    show: false,
    error: false,
    email: '',
  },
  isListSelected: false,
};

export const audienceListsReducerV2 = (state = audienceListsInitialState, action: IAudienceListAction) => {
  const newState = { ...state };
  const { payload } = action;
  switch (action.type) {
    case AUDIENCE_LISTS.LOAD:
      newState.loading = true;
      return newState;

    case AUDIENCE_LISTS.SUCCESS:
      newState.loading = false;
      newState.page = state.page + 1;
      if (action.payload) {
        if (newState.lists.length > 0) {
          newState.lists = [...newState.lists, ...(payload.lists as IListItem[])];
        } else {
          newState.lists = payload.lists as IListItem[];
        }
        if (payload.offset === 0) {
          newState.totalLists = payload.totalLists as number;
        }

        if (payload.message) {
          newState.message = payload.message as string;
        }
        // payload.offset === 0 && (newState.totalLists = payload.totalLists);
        newState.success = true;
        // console.log(action.payload);
      }
      return newState;

    case AUDIENCE_LISTS.TOTAL_CONTACTS_UPDATE: {
      const { type, listId, totalContacts, replaceCount } = action.payload;
      console.info('reducer payload', action.payload);
      if (type === ActionTypes.DELETE || type === ActionTypes.REMOVE) {
        newState.lists.forEach((list, index) => {
          if (list.listId === Number(listId)) {
            newState.lists[index].totalContacts -= totalContacts as number;
          }
        });
      } else if (type === ActionTypes.ADD_TO_LIST && replaceCount) {
        newState.lists.forEach((list, index) => {
          if (list.listId === Number(listId)) {
            newState.lists[index].totalContacts = totalContacts as number;
          }
        });
      } else if (type === ActionTypes.CREATE || type === ActionTypes.ADD_TO_LIST) {
        newState.lists.forEach((list, index) => {
          if (list.listId === Number(listId)) {
            newState.lists[index].totalContacts += totalContacts as number;
          }
        });
      }
      return newState;
    }

    case AUDIENCE_LISTS.LIST_NAME_UPDATE: {
      const { listId, listName } = action.payload;
      newState.lists.forEach((list, index) => {
        if (list.listId === Number(listId)) {
          newState.lists[index].listName = listName as string;
        }
      });
      return newState;
    }

    case AUDIENCE_LISTS_SEARCH.LOAD:
      newState.searchedLoading = true;
      return newState;

    case AUDIENCE_LISTS_SEARCH.SUCCESS:
      newState.searchedLoading = false;
      newState.searchedPage = state.searchedPage + 1;
      if (action.payload) {
        if (newState.searchedLists.length > 0) {
          newState.searchedLists = [...newState.searchedLists, ...(payload.lists as IListItem[])];
        } else {
          newState.searchedLists = payload.lists as IListItem[];
        }

        if (payload.offset === 0) {
          newState.totalSearchedLists = payload.totalLists as number;
        }

        newState.success = true;
      }
      return newState;

    case AUDIENCE_LISTS_SEARCH.FAIL:
      newState.searchedLoading = false;
      return newState;

    case AUDIENCE_LISTS.LISTS_RESET:
      newState.loading = false;
      newState.lists = [];
      newState.totalLists = 0;
      return newState;

    case AUDIENCE_LISTS_SEARCH.RESET:
      newState.searchedLists = [];
      newState.searchedLoading = false;
      newState.searchedPage = 0;
      newState.searchTerm = '';
      newState.totalSearchedLists = 0;
      return newState;

    case AUDIENCE_LISTS.FAIL:
      newState.loading = false;
      if (action.payload) {
        newState.listAlreadyExists = !newState.listAlreadyExists;
      }
      return newState;

    case AUDIENCE_LISTS_SEARCH.SET_SEARCH:
      if (payload.searchTerm) {
        if (payload.searchTerm !== newState.searchTerm) {
          // newState.check = !newState.check;
          newState.searchTerm = payload.searchTerm as string;
          newState.searchedLists = [];
          // newState.searchedLoading = false;
          newState.searchedPage = 0;
          newState.totalSearchedLists = 0;
        }
      }
      return newState;

    case AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM:
      newState.success = payload.success as boolean;
      newState.message = payload.message as string;
      return newState;

    case AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM_LOADING:
      newState.searchedLoading = false;
      newState.loading = false;
      return newState;

    // DELETE LIST LOGIC
    case AUDIENCE_LISTS_DELETE.LOAD:
      newState.deleteList.loading = true;
      return newState;

    case AUDIENCE_LISTS_DELETE.SUCCESS: {
      const { message, success, listIds, isSearched } = payload;
      const activeList = isSearched ? newState.searchedLists : newState.lists;
      const remainingLists = activeList.filter((list) => !(listIds as number[]).includes(list.listId));
      if (isSearched) {
        const newSearchListCount = newState.totalSearchedLists - (activeList.length - remainingLists.length);
        newState.totalSearchedLists = newSearchListCount;
        newState.searchedLists = remainingLists;
      } else {
        newState.lists = remainingLists;
      }
      newState.loading = false;
      newState.deleteList.loading = false;
      newState.deleteList.success = success as boolean;
      newState.deleteList.message = message as string;
      newState.totalLists -= (listIds as number[]).length;
      return newState;
    }

    case AUDIENCE_LISTS_DELETE.FAIL:
      newState.deleteList.loading = false;
      newState.deleteList.error = true;
      return newState;

    case AUDIENCE_LISTS_DELETE.RESET:
      newState.deleteList = {
        loading: false,
        success: false,
        error: false,
        message: '',
      };
      return newState;

    // CLONE LIST LOGIC
    case CLONE_LIST.LOAD:
      newState.cloneList.loading = true;
      return newState;

    case CLONE_LIST.SUCCESS: {
      // eslint-disable-next-line
      const { success, message, listData, listId, isSearched } = payload;
      const cloneListData = listData as IListItem;
      cloneListData.lastUpdated = 'just now';
      if (isSearched) {
        const indexOfList = newState.searchedLists.findIndex((list) => list.listId === Number(listId));
        newState.searchedLists.splice(indexOfList + 1, 0, cloneListData);
        newState.searchedLists = [...newState.searchedLists];
        newState.totalSearchedLists += 1;
      }
      const indexOfList = newState.lists.findIndex((list) => list.listId === Number(listId));
      newState.lists.splice(indexOfList + 1, 0, cloneListData);
      newState.lists = [...newState.lists];
      newState.totalLists += 1;
      newState.cloneList.loading = false;
      newState.cloneList.success = success as boolean;
      newState.cloneList.message = message as string;
      return newState;
    }

    case CLONE_LIST.FAIL:
      newState.cloneList.loading = false;
      return newState;

    case AUDIENCE_LISTS.IMPORT_LIST_SUCCESS:
      newState.lists = [payload.listItem as IListItem, ...newState.lists];
      newState.totalLists += 1;
      return newState;

    case AUDIENCE_LISTS_ADD.LOAD:
      newState.addNewList.loading = true;
      return newState;

    case AUDIENCE_LISTS_ADD.SUCCESS:
      newState.lists = newState.lists.filter((list) => list.listId !== payload.listItem.listId);
      newState.addNewList.loading = false;
      newState.addNewList.success = true;
      newState.addNewList.message = (payload.message as string) ?? '';
      newState.lists = [payload.listItem as IListItem, ...newState.lists];
      newState.lists[0].lastUpdated = 'just now';
      newState.totalLists += 1;
      return newState;

    case AUDIENCE_LISTS_ADD.FAIL:
      newState.addNewList.loading = false;
      newState.addNewList.error = true;
      newState.addNewList.message = (action.message as string) ?? '';
      return newState;

    case AUDIENCE_LISTS_ADD.RESET:
      newState.addNewList = {
        loading: false,
        success: false,
        error: false,
        message: '',
      };
      return newState;

    case AUDIENCE_LISTS.ENABLE_EXPORT_LOADER:
      newState.exportPopup.loading = true;
      return newState;
    case AUDIENCE_LISTS.DISABLE_EXPORT_LOADER:
      newState.exportPopup.loading = false;
      return newState;
    case AUDIENCE_LISTS.SET_OPEN:
      newState.exportPopup.show = true;
      newState.exportPopup.error = false;
      newState.exportPopup.loading = false;
      if (action.payload) newState.exportPopup.email = action.payload.exportEmail as string;
      return newState;
    case AUDIENCE_LISTS.SET_ERROR:
      newState.exportPopup.error = true;
      newState.exportPopup.loading = false;
      return newState;
    case AUDIENCE_LISTS.SET_CLOSE:
      newState.exportPopup.error = false;
      newState.exportPopup.show = false;
      newState.exportPopup.loading = false;
      return newState;

    case AUDIENCE_LISTS_SELECTION.SET:
      newState.isListSelected = true;
      return newState;

    case AUDIENCE_LISTS_SELECTION.RESET:
      newState.isListSelected = false;
      return newState;

    case AUDIENCE_LISTS.NAMES_LOAD:
      newState.listsDataNamesLoading = true;
      return newState;

    case AUDIENCE_LISTS.NAMES_LOAD_SUCCESS:
      newState.listsDataNamesLoading = false;
      if (action.payload.listsDataNames) newState.listsDataNames = action.payload.listsDataNames as IListItemNames[];
      return newState;

    case AUDIENCE_LISTS.NAMES_FAIL:
      newState.listsDataNamesLoading = false;
      return newState;

    case AUDIENCE_LISTS.NAMES_RESET:
      newState.listsDataNamesLoading = false;
      newState.listsDataNames = [];
      return newState;

    default:
      return newState;
  }
};
